(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('CampaignListController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'campaigns'];

    function Controller($scope, topBarService, campaigns) {

        $scope.campaigns = campaigns;

        topBarService.setTitleAndIcon('Campaigns', 'fa fa-bullhorn');
    }
})();